import client from './client';

export const strategyAPI = {
  getPerformance: (params = {}) =>
    client.get('/admin/performance', { params }),
};